module.exports = __webpack_public_path__ + "static/media/success.35f323bc.gif";